module.exports = __webpack_public_path__ + "static/assets/514fde34bbbb5ea4d96eff9e5ad5afc0.svg";